module.exports = __webpack_public_path__ + "img/specials-multislider-6040--chevrolet.d072f84e.jpeg";